import {
  Smile,
  Bird,
  Bone,
  Brain,
  Sparkles,
  HeartPulse,
  Eye,
  Siren,
  Activity,
  Heart,
  type LucideIcon,
} from "lucide-react";

export const SPECIALIST_BADGES = [
  { id: "dentistry", label: "Dentistry", icon: Smile },
  { id: "exotics", label: "Exotics", icon: Bird },
  { id: "orthopaedics", label: "Orthopaedics", icon: Bone },
  { id: "behaviour", label: "Behaviour", icon: Brain },
  { id: "dermatology", label: "Dermatology", icon: Sparkles },
  { id: "cardiology", label: "Cardiology", icon: HeartPulse },
  { id: "ophthalmology", label: "Ophthalmology", icon: Eye },
  { id: "emergency", label: "Emergency & Critical Care", icon: Siren },
  { id: "rehab", label: "Rehab & Physiotherapy", icon: Activity },
  { id: "end_of_life", label: "End-of-life Care", icon: Heart },
] as const;

export type SpecialistBadgeId = (typeof SPECIALIST_BADGES)[number]["id"];

export const getSpecialistBadgeLabel = (id: string) =>
  SPECIALIST_BADGES.find((b) => b.id === id)?.label ?? id;

export const getSpecialistBadgeIcon = (id: string): LucideIcon | null =>
  SPECIALIST_BADGES.find((b) => b.id === id)?.icon ?? null;

